export default {
  data: () => ({
    metaHeader: [],
    linkHeader: [],
    title: null
  }),
  head() {
    return {
      title: this.title,
      meta: this.metaHeader,
      link: this.linkHeader,
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          type: 'text/javascript',
          innerHTML: '(function(d, s, id) {\n' +
              '  var js, ljs = d.getElementsByTagName(s)[0];\n' +
              '  if (d.getElementById(id)) return;\n' +
              '  js = d.createElement(s); js.id = id;\n' +
              '  js.src = "https://storage.googleapis.com/lgmap/p9mrrz9zx2f60K18AiJS.js";\n' +
              '  ljs.parentNode.insertBefore(js, ljs);\n' +
              '}(document, \'script\', \'lgmap\'));',
          async: true
        }
      ]
    };
  },
}
